<template>
  <form class="form-inline my-2 my-lg-0 form-search order-5" @submit.prevent="search">
    <b-button
            class="my-2 my-sm-0 form-search__btn"
            :class="{loading: loading}"
            type="submit"
            :disabled="loading"
            @click="$refs.searchInput.focus()"
    >
      <b-spinner small v-if="loading" variant="dark"></b-spinner>
    </b-button>
    <input
            ref="searchInput"
            class="form-control form-search__input"
            type="search"
            placeholder="Search..."
            aria-label="Search"
            :value="searchQuery"
            @input.trim="({target}) => setSearchQuery(target.value)"
    />
    <input class="form-search__close" type="reset" @click="clearSearch"/>
    <div class="search-result"
         :class="{active: searchResult.length}"
    >
      <ul>
        <li v-for="{id, title, slug, category} in searchResult" :key="id">
          <a :href="`${lang_prefix}/${category.parent.slug}/${category.slug}/${slug}`">{{$lang(title)}}</a>
        </li>
      </ul>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import $ from 'jquery'

export default {
  name: 'Search',
  computed: {
    ...mapGetters('search', ['searchResult', 'searchQuery', 'loading']),
    lang_prefix () {
      return this.$currentLang === 'ru' ? '/ru' : ''
    },
  },
  methods: {
    ...mapMutations('search', {removeSearchQuery: 'removeSearchQuery'}),
    ...mapActions('search', ['setSearchQuery', 'search']),
    clearSearch () {
      this.removeSearchQuery()
      this.$refs.searchInput.blur()
      $('#header__nav').removeClass('search-open')
    }
  },
}
</script>

<style scoped lang="scss">

  .form-search__close {
    color: transparent;
  }

  .form-search__btn {
    display: inline-flex;
    align-items: center;
  }

  .form-search__btn.loading {
    background: #fff;
  }

  .form-search {
    position: relative;
  }

  .navbar {
    &.search-open {
      .search-result.active {
        opacity: 1;
      }
    }

    .search-result {
      padding: 1rem;
      opacity: 0;
      overflow: scroll;
      max-height: 600px;
      transition: all 0.2s ease-in-out;
      position: absolute;
      top: 104%;
      left: 0;
      right: 0;
      background-color: #fff;
    }
  }
</style>
